import request, { REQUEST_METHODS } from '@api/Request';
import { NprEndpoints } from './config';
import { AddNprRequest, AddNprResponse, GetNprResponse, UpdateNprResponse } from './types';

export default class NprService {
  public static readonly addNpr = (data: AddNprRequest): Promise<AddNprResponse> =>
    request({
      url: NprEndpoints.addNpr(),
      method: REQUEST_METHODS.POST,
      data,
    });
  public static readonly updateNpr = (data: any): Promise<UpdateNprResponse> =>
    request({
      url: NprEndpoints.updateNpr(),
      method: REQUEST_METHODS.POST,
      data,
    });
  public static readonly getNpr = (projectID: number, requestID: number, version: number): Promise<GetNprResponse> =>
    request({
      url: NprEndpoints.getNpr(),
      method: REQUEST_METHODS.GET,
      params: { projectID, requestID, version },
    });
}
